import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["className", "prefixCls", "children"];
import React from 'react';
import "./styles/index.css";
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
export default function MonorepoTemplate(props) {
  if (props === void 0) {
    props = {};
  }
  var {
      className,
      prefixCls = 'w-template',
      children
    } = props,
    others = _objectWithoutPropertiesLoose(props, _excluded);
  var cls = [className, prefixCls].filter(Boolean).join(' ');
  return /*#__PURE__*/_jsx("div", _extends({}, others, {
    className: cls,
    children: children && React.Children.map(children, child => {
      if (/*#__PURE__*/React.isValidElement(child)) return child;
      return /*#__PURE__*/_jsxs("span", {
        children: [" ", child, " "]
      });
    })
  }));
}